// src/components/User/TermsOfService.js
import React from 'react';
import { Helmet } from 'react-helmet';
import Header from './Header';
import Footer from './Footer';

export default function TermsOfService() {
    return (
        <>
            <Helmet>
                <title>Terms & Conditions | Anindya Chowdhury</title>
                <meta
                    name="description"
                    content="Terms & Conditions governing the use of anindyachowdhury.com."
                />
            </Helmet>

            <Header />

            <main
                className="px-6 md:px-12 lg:px-36 py-16 max-w-4xl mx-auto leading-relaxed"
                style={{ color: 'var(--text-primary)' }}
            >
                <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-2">
                    Terms &amp; Conditions
                </h1>
                <p className="text-sm mb-10" style={{ color: 'var(--text-secondary)' }}>
                    Effective Date: September 15, 2026
                </p>

                <div className="space-y-8 text-base md:text-[1.05rem]" style={{ color: 'var(--text-secondary)' }}>
                    <p>
                        By accessing anindyachowdhury.com (the “Website”), you agree to these Terms &amp; Conditions.
                    </p>

                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                            Website Content
                        </h2>
                        <p className="mb-3">
                            The content on this Website is provided for general informational purposes. It may include opinions, observations, frameworks, examples, and information about my professional experience and services.
                        </p>
                        <p>
                            Nothing on the Website constitutes legal, financial, investment, tax, or other regulated professional advice.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                            Consulting Services
                        </h2>
                        <p className="mb-3">
                            Information on this Website does not constitute an offer or guarantee that consulting services will be provided.
                        </p>
                        <p>
                            Any consulting engagement will be subject to a separate written agreement, proposal, statement of work, or other mutually agreed terms between the parties.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                            No Guarantee of Results
                        </h2>
                        <p>
                            Consulting recommendations are based on the information, circumstances, assumptions, and resources available at the time. I do not guarantee any particular business, financial, growth, revenue, retention, or other result.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                            Intellectual Property
                        </h2>
                        <p className="mb-3">
                            Unless otherwise stated, the text, design, graphics, and other original content on this Website are owned by Anindya Chowdhury and may not be reproduced, copied, distributed, or commercially exploited without prior permission.
                        </p>
                        <p>
                            Client names, company references, and descriptions of previous work may be subject to confidentiality obligations. Where applicable, confidential client information will not be disclosed.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                            Third-Party Links and Services
                        </h2>
                        <p>
                            The Website may contain links to third-party websites or services. I am not responsible for the content, availability, security, or practices of third-party websites.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                            Website Availability
                        </h2>
                        <p>
                            I make reasonable efforts to keep the Website available and accurate, but I do not guarantee that the Website will always be available, error-free, or free from interruptions.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                            Limitation of Liability
                        </h2>
                        <p>
                            To the maximum extent permitted by applicable law, I will not be liable for losses arising from your use of, or reliance on, information available through the Website.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                            Changes to These Terms
                        </h2>
                        <p>
                            I may update these Terms &amp; Conditions from time to time. Updated terms will be posted on this page with a revised effective date.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                            Governing Law
                        </h2>
                        <p>
                            These Terms &amp; Conditions shall be governed by and interpreted in accordance with the applicable laws of India.
                        </p>
                    </div>

                    <div className="pt-6 border-t border-[rgba(0,0,0,0.08)]">
                        <h2 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                            Contact
                        </h2>
                        <p className="mb-2">For questions regarding these Terms:</p>
                        <p className="font-semibold" style={{ color: 'var(--text-primary)' }}>
                            Anindya Chowdhury
                        </p>
                        <p>
                            Email:{' '}
                            <a
                                href="mailto:anindya@buzztobrand.com"
                                className="font-medium hover:underline"
                                style={{ color: 'var(--color-primary)' }}
                            >
                                anindya@buzztobrand.com
                            </a>
                        </p>
                    </div>
                </div>
            </main>

            <Footer />
        </>
    );
}
